import React from "react";
import MainLoader from '../../icons/MainLoader/MainLoader'
import useStartPageLogic from './hooks/useStartPageLogic'


const StartPage = () => {
    
    useStartPageLogic()

    return <MainLoader />
}

export default StartPage;